import { useIntl } from 'react-intl';

import sortMessages from '@/components/Search/components/SortSection/messages';
import { sortCriteria } from '@/components/Search/utils';

const useFormattedSortMessages = () => {
  const { formatMessage } = useIntl();
  const formattedSortCriteria = sortCriteria.map((sortCriteria) =>
    formatMessage(sortMessages.sortCriteria, { selector: sortCriteria })
  );
  return {
    formattedSortCriteria,
  };
};

export default useFormattedSortMessages;
